








































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import GlobalResults from '~/components/Distribution/GlobalResults.vue';
import { ICurrentPage } from '~/store/types';
import distributionResultsQuery from '~/queries/distributionResults.gql';
import { addDays, format } from 'date-fns';

@Component({
  components: {
    GlobalResults,
  },
})
export default class DistributionResults extends Vue {
  isModalOpen = false;
  isFetching = true;
  distributionStartDate = null;
  distributionEndDate: Date | null = null;
  initialDistributionDate: Date | null = null;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  distributionData: any = null;

  get distributionDate() {
    const dateString = this.$nuxt.$route.query.date;

    if (dateString) {
      return new Date(+dateString);
    }

    return new Date();
  }

  get tokenType() {
    const type = this.$nuxt.$route.query.tokenType;
    if (type) {
      return type;
    }

    return 'gala';
  }

  get formattedDate() {
    return format(this.distributionDate, 'MMMM d');
  }

  @Watch('distributionDate')
  async onDateChange() {
    this.isFetching = true;
    this.distributionData = null;

    await this.getDistributionResults().catch(error => {
      this.$sentry.captureException(error);
      this.updateSnackbarErrorText(
        this.$t('pages.distribution.index.errorMsg') as string,
      );
      this.toggleErrorSnackbar();
    });

    this.isFetching = false;
  }

  async created() {
    this.updateCurrentPage({
      title: 'Distribution Results',
      backIcon: 'arrow_back_ios',
      backRoute: '/balances/GALA',
      forceBackRoute: true,
    });

    await this.getDistributionResults().catch(error => {
      this.$sentry.captureException(error);
      this.updateSnackbarErrorText(
        this.$t('pages.distribution.index.errorMsg') as string,
      );
      this.toggleErrorSnackbar();
    });
    this.initialDistributionDate = this.distributionDate;

    this.isFetching = false;
  }

  getIsPreviousOrNextDayValid(daysToAdd: number) {
    const newDate = addDays(this.distributionDate, daysToAdd);
    const initialDistributionString = this.initialDistributionDate
      ? this.initialDistributionDate.toString()
      : '';
    const newDateString = newDate ? newDate.toString() : '';

    if (this.distributionEndDate !== null && newDate !== null) {
      return (
        // @ts-ignore
        newDate > this.distributionStartDate &&
        (newDate < this.distributionEndDate ||
          initialDistributionString === newDateString)
      );
    }

    return false;
  }

  getPreviousOrNextDayLink(daysToAdd: number) {
    const newDate = addDays(this.distributionDate, daysToAdd);

    return `/distribution?date=${newDate.getTime()}&tokenType=${
      this.tokenType
    }`;
  }

  async getDistributionResults() {
    const response = await this.$apollo.query({
      query: distributionResultsQuery,
      variables: { date: this.distributionDate, tokenType: this.tokenType },
    });

    const { distributionGlobalResults, validDistributionDates } = response.data;
    this.distributionStartDate = validDistributionDates.start;
    this.distributionEndDate = validDistributionDates.end;

    this.distributionData = {
      globalResults: distributionGlobalResults,
    };
  }
  goTo(route: string) {
    this.$router.push(route);
  }
}
